export default "__VITE_ASSET__BWQV_dVs__"